import React, { ForwardedRef, forwardRef,  useImperativeHandle, useLayoutEffect, useRef, useState } from "react";
import GUI, { IGUIProps } from "../GUI";

export type TMeasureProps = IGUIProps & {
    id?:string
    contentClass?:string
    overflowContent?:React.ReactNode
    children:React.ReactNode
    onMeasure?:(overflow:boolean) => void
}
export interface IMeasure {
    container:HTMLDivElement|null
}
export default forwardRef( (props:TMeasureProps, ref?:ForwardedRef<IMeasure>) => {
    const [overflow,setOverlow] = useState<boolean>(false)
    const container = useRef<HTMLDivElement|null>(null)
    const content = useRef<HTMLDivElement|null>(null)

    useImperativeHandle(ref, () => ({
       get container() { return container.current }
    }), [])

    useLayoutEffect(() => {
        if (!container.current || !content.current) return
        const observer = new ResizeObserver(() => {
            if (!container.current || !content.current) return
            const overflow = content.current.clientWidth>container.current.clientWidth
            props.onMeasure?.(overflow)
            setOverlow(overflow)
        })
        observer.observe(container.current)
        return () => { observer.disconnect() }
    }, [props.children])

    const id = props.id ? {id:props.id} : {}
    const css:React.CSSProperties = {width:"max-content"}
    if (overflow && props.overflowContent) {
        css.visibility = "hidden"
        css.position = "absolute"
    }

    return <div className={GUI.joinClass("measure", props.className, overflow ? "overflow" : "")} ref={container} {...id} style={{overflow:"hidden"}}>
        {overflow ? props.overflowContent : null}
        <div ref={content} className={GUI.joinClass("measure-content", props.contentClass)} style={{width:"max-content",...css}}>{props.children}</div>
    </div>
})